import {
	TAllCallLogs,
	TCallDuration,
	THourlyCallLogs,
	TTextLogs,
	TWeeklyCallLogs,
} from '@/types/TAnalytics';
import apiClient from '@/utils/apiClient';

const agentPrefix = '/agent/:agentId';
const GET_ANALYTICS_API_PATH = `/api/v2/receptionist-dashboard${agentPrefix}/analytics/weekly-usage`;
const GET_YEARLY_ANALYTICS_API_PATH = `/api/v2/receptionist-dashboard${agentPrefix}/analytics/yearly-usage`;
const GET_TEXT_LOGS_ANALYTICS_API_PATH = `/api/v2/receptionist-dashboard${agentPrefix}/analytics/text-logs`;

export const getWeeklyUsageData = async ({
	agentId,
	query,
}: {
	agentId: string;
	query: {
		days?: number;
		startDate?: number;
		endDate?: number;
	};
}): Promise<{
	weeklyCallLogs: TWeeklyCallLogs[];
	hourlyCallLogs: THourlyCallLogs[];
	callDuration: TCallDuration[];
}> => {
	let queryParamString = '?';

	if (query.days) {
		queryParamString += `days=${query.days}`;
	}

	if (query.startDate) {
		queryParamString += `&startDate=${query.startDate}`;
	}

	if (query.endDate) {
		queryParamString += `&endDate=${query.endDate}`;
	}

	const response = await apiClient.request({
		method: 'GET',
		endPoint: `${GET_ANALYTICS_API_PATH.replace(':agentId', agentId)}${queryParamString}`,
	});

	return response;
};

export const getYearlyUsageData = async ({
	agentId,
}: {
	agentId: string;
}): Promise<TAllCallLogs> => {
	const response = await apiClient.request({
		method: 'GET',
		endPoint: `${GET_YEARLY_ANALYTICS_API_PATH.replace(':agentId', agentId)}`,
	});
	return response;
};

export const getTextLogsAnalytics = async ({
	agentId,
}: {
	agentId: string;
}): Promise<{ allTextLogs: TTextLogs[] }> => {
	const response = await apiClient.request({
		method: 'GET',
		endPoint: `${GET_TEXT_LOGS_ANALYTICS_API_PATH.replace(':agentId', agentId)}`,
	});

	return response;
};
